import { useState } from 'react'
import ActionButton from 'components/ActionButton'
import IconWrapper from 'components/IconWrapper'
import StatusCheckPriorAuthorizationModal from 'modals/StatusCheckPriorAuthorizationModal'
import { Eye } from 'react-feather'

type StatusCheckPriorAuthorizationButtonProps = {
  disabled?: boolean
  onClick: (message: string) => void
}

export const StatusCheckPriorAuthorizationButton = ({
  disabled = false,
  onClick,
}: StatusCheckPriorAuthorizationButtonProps): JSX.Element => {
  const [openModal, setOpenModal] = useState(false)

  const handleOnClick = (message: string) => {
    onClick(message)
    setOpenModal(false)
  }

  return (
    <>
      <ActionButton
        disabled={disabled}
        icon={
          <IconWrapper>
            <Eye />
          </IconWrapper>
        }
        label="Status Check"
        onClick={() => setOpenModal(true)}
      />
      <StatusCheckPriorAuthorizationModal
        isOpen={openModal}
        onClick={handleOnClick}
        onDismiss={() => setOpenModal(false)}
      />
    </>
  )
}
